import { useEffect, useState } from "react";
import TreeView from "src/Components/TreeView";
import { ITreeViewData } from "src/Components/TreeView/types";
import useSearchParam from "src/Hooks/useSearchParam";
import {
  Button,
  DatePicker,
  DynamicDropdown,
  Form,
  FullScreenLoading,
  TextInput,
  TimePicker,
} from "src/Components";
import { IAdjustmentLogsSearchParam } from "src/Interfaces/applyOption";
import UsersDropdown from "src/Components/Dropdown/Users/UsersDropdown";
import { getLogs } from "src/Requests/adjustment";
import { packetErrorHandler } from "src/Utils/requestUtils";
import { getGroups } from "src/Requests/optionDomain";
import moment from "moment";

const Logs = () => {
  const [treeViewData, setTreeViewData] = useState({} as ITreeViewData);
  const [searchParams, setSearchParams] = useState({
    date: moment().format("YYYY-MM-DD"),
    fromTime: "9:00:00",
    toTime: "12:30:00",
    params: {
      scopeType: "AdjustmentJob",
    },
  } as IAdjustmentLogsSearchParam);

  const [timeISOs, setTimeISOs] = useState(getInitialTimeISOValues);
  const [loading, setLoading] = useState(false);

  function fetchData(sp: IAdjustmentLogsSearchParam) {
    setLoading(true);
    getLogs(sp)
      .then((resp) => {
        setTreeViewData(resp);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  }

  function getInitialTimeISOValues() {
    const padTime = (timeStr: string) => {
      // "9:00:00" → ["9", "00", "00"] → "09:00:00"
      const parts = timeStr.split(":");
      const [h = "00", m = "00", s = "00"] = parts;
      return `${h.padStart(2, "0")}:${m.padStart(2, "0")}:${s.padStart(
        2,
        "0"
      )}`;
    };

    const safeDateTimeString = (date: string, time: string) => {
      const paddedTime = padTime(time);
      return new Date(`${date}T${paddedTime}`).toISOString();
    };

    return {
      fromTime: safeDateTimeString(searchParams.date, searchParams.fromTime),
      toTime: safeDateTimeString(searchParams.date, searchParams.toTime),
    };
  }
  const paramsChangeHandler = (name: string, value: any) => {
    setSearchParams({
      ...searchParams,
      params: {
        ...searchParams.params,
        [name]: value ? value : undefined,
      },
    });
  };

  const searchParamChangeHandler = (name: string, value: any) => {
    setSearchParams({ ...searchParams, [name]: value });
  };

  const timeChangeHandler = (
    name: string,
    value: { ISOString: string | null; timeString: string }
  ) => {
    searchParamChangeHandler(name, value.timeString);
    setTimeISOs({ ...timeISOs, [name]: value.ISOString });
  };

  return (
    <div className="flex flex-row justify-start items-start gap-5 p-5">
      {loading ? <FullScreenLoading /> : <></>}
      <Form className="!w-80  py-2 px-2 !mx-auto gap-2">
        <DatePicker
          label="تاریخ"
          name="date"
          onChange={searchParamChangeHandler}
          value={searchParams.date}
        />
        <div className="flex flex-row justify-start items-center gap-3 w-full">
          <TimePicker
            name="fromTime"
            onChange={timeChangeHandler}
            placeholder="شروع"
            value={timeISOs.fromTime}
          />
          <TimePicker
            name="toTime"
            onChange={timeChangeHandler}
            placeholder="پایان"
            value={timeISOs.toTime}
          />
        </div>
        <DynamicDropdown
          dropdown={{
            name: "groupId",
            placeholder: "گروه",
            extraLabel: true,
          }}
          getData={getGroups}
          onChange={paramsChangeHandler}
          value={searchParams?.params?.groupId}
        />
        <UsersDropdown
          label="کاربر"
          name="userId"
          onChange={paramsChangeHandler}
          extraLabel
          value={searchParams?.params?.userId}
        />
        <TextInput
          name="scopeType"
          label="scopeType"
          value={searchParams?.params?.scopeType}
          extraLabel
          onChange={paramsChangeHandler}
        />
        <Button
          onClick={() => {
            fetchData(searchParams);
          }}
          variant="contained"
          text="جستجو"
        />
      </Form>
      <div className="w-full max-h-[700px] overflow-auto border border-gray-300 rounded shadow h-max">
        <TreeView data={[treeViewData]} />
      </div>
    </div>
  );
};

export default Logs;
